import * as React from "react";
const SvgRectangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 3, height: 14, viewBox: "0 0 3 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 3, height: 14, fill: "#00AFCC" }));
export default SvgRectangle;
